import * as React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface NumberInputProps {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

export function NumberInput({
  value,
  onChange,
  min,
  max,
  step = 1,
  className,
  placeholder,
  disabled,
}: NumberInputProps) {
  const clamp = (v: number) => {
    if (typeof min === 'number' && v < min) return min;
    if (typeof max === 'number' && v > max) return max;
    return v;
  };

  const bump = (dir: 1 | -1) => onChange(clamp(value + dir * step));

  return (
    <div
      className={cn(
        'group inline-flex h-10 items-stretch rounded-md border border-white/10 bg-eol-black/40 overflow-hidden focus-within:ring-2 focus-within:ring-eol-pink/50 focus-within:border-eol-pink/40 transition',
        disabled && 'opacity-50 pointer-events-none',
        className,
      )}
    >
      <input
        type="number"
        value={Number.isFinite(value) ? value : ''}
        onChange={(e) => {
          const n = e.target.value === '' ? 0 : Number(e.target.value);
          onChange(Number.isNaN(n) ? 0 : clamp(n));
        }}
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        className="w-full bg-transparent px-3 text-sm text-eol-white placeholder:text-eol-desc focus:outline-none"
      />
      <div className="flex flex-col border-l border-white/10">
        <button
          type="button"
          tabIndex={-1}
          onClick={() => bump(1)}
          className="flex-1 px-2 text-eol-desc hover:text-eol-pink hover:bg-white/5 transition"
          aria-label="Увеличить"
        >
          <ChevronUp className="h-3 w-3" />
        </button>
        <button
          type="button"
          tabIndex={-1}
          onClick={() => bump(-1)}
          className="flex-1 px-2 text-eol-desc hover:text-eol-pink hover:bg-white/5 border-t border-white/10 transition"
          aria-label="Уменьшить"
        >
          <ChevronDown className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
}
